import { render, staticRenderFns } from "./QuestionSecond.vue?vue&type=template&id=2d708b40"
import script from "./QuestionSecond.vue?vue&type=script&lang=js"
export * from "./QuestionSecond.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports